export const CONTACT = {
  bookingUrl:
    "https://teams.microsoft.com/l/meeting/new?subject=Libros%20Consulting%20Consultation&attendees=srinivasan.rajagopalan@librosconsulting.com", // Teams new-meeting deep link — replace with Microsoft Bookings URL when available
  whatsappNumber: "919940631619",
  whatsappMessage:
    "Hello Libros Consulting,\nI found your website and would like to discuss a Publishing / Accessibility / Content Management project.\nPlease get back to me.\nThank you.",
  salesEmail: "sales@librosconsulting.in",
  generalEmail: "info@librosconsulting.com",
  website: "www.librosconsulting.com",
  linkedin: "https://www.linkedin.com/in/libros-consulting-142068328/",
};

export const whatsappHref = () =>
  `https://wa.me/${CONTACT.whatsappNumber}?text=${encodeURIComponent(CONTACT.whatsappMessage)}`;
